import { AllCalibrationResponseModel, CalibrationResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, UploadedFile, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { CalibrationService } from './calibration.service';
import { CalibrationDto } from './dto/calibration.dto';
import { CalibrationIdReq } from './dto/calibration.req';
import { FileInterceptor, FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import path, { extname } from 'path';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { FilesUploadDto } from './dto/calibration-fileUpload.dto';

const fileDirectory = __dirname.replace(/\\dist/, '')

@ApiTags('calibrations')
@Controller('calibrations')
export class CalibrationController {

    constructor(
        private service: CalibrationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createCalibration')
    async createCalibration(@Body() DTO: CalibrationDto, isUpdate: boolean = false): Promise<CalibrationResponseModel> {
        try {
            return await this.service.createCalibration(DTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CalibrationResponseModel, error);
        }
    }

    @Post('/updateCalibration')
    async updateCalibration(@Body() DTO: CalibrationDto, isUpdate: boolean = false): Promise<CalibrationResponseModel> {
        try {
            return await this.service.createCalibration(DTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CalibrationResponseModel, error);
        }
    }

    @Post('/getAllCalibrations')
    async getAllCalibrations(@Body() DTO: CalibrationIdReq): Promise<AllCalibrationResponseModel> {
        try {
            return await this.service.getAllCalibrations(DTO);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllCalibrationResponseModel, error);
        }
    }

    @Post('/getAllActiveCalibrations')
    async getAllActiveCalibrations(): Promise<AllCalibrationResponseModel> {
        try {
            return await this.service.getAllActiveCalibrations();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllCalibrationResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateData')
    async activateOrDeactivateData(@Body() req: CalibrationIdReq): Promise<CalibrationResponseModel> {
        try {
            return await this.service.activateOrDeactivateCalibrations(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CalibrationResponseModel, error);
        }
    }

    // @Post('calibrateFileUpload')
    // @ApiConsumes('multipart/form-data')
    // @UseInterceptors(FileInterceptor('file', {
    //     limits: { files: 1 },
    //     storage: diskStorage({
    //         //,../../../../../../masters-upload-files
    //         destination: path.join(fileDirectory, '../../../', 'masters-upload-files'),
    //         filename: (req, file, callback) => {
    //             const name = file.originalname.split('.')[0];
    //             const fileExtName = extname(file.originalname);
    //             const randomName = Array(4)
    //                 .fill(null)
    //                 .map(() => Math.round(Math.random() * 16).toString(16))
    //                 .join('');
    //             callback(null, `${name}-${randomName}${fileExtName}`);
    //         },
    //     }),
    //     fileFilter: (req, file, callback) => {
    //         if (!file.originalname.match(/\.(pdf|xlsx|xls|png|jpeg|jpg|pjpeg|gif|tiff|x-tiff|x-png|csv)$/i)) {
    //             return callback(new Error('Only Excel files are allowed!'), false);
    //         }
    //         callback(null, true);
    //     },
    // }))
    // async uploadFile(@UploadedFile() file, @Body() req: any) {
    //     try { 
    //         return await this.service.colabrationFileSave(file, req)
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(CommonResponse, error);
    //     }
    // }

    @Post('calibrateFileUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FilesInterceptor('file', 10, { // Change 'file' to 'files' and allow multiple files with a limit of 10
        storage: diskStorage({
            destination: path.join(fileDirectory, '../../../', 'masters-upload-files'),
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(pdf|xlsx|xls|png|jpeg|jpg|pjpeg|gif|tiff|x-tiff|x-png|csv)$/i)) {
                return callback(new Error('Only specific file types are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async uploadFiles(@UploadedFiles() file:File[], @Body() req:FilesUploadDto): Promise<CommonResponse> {
        try { 
            return await this.service.colabrationFileSave(file, req); // Adjust to handle multiple files
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}
